export default function useSocialMediaIcons() {
  const getSocialMediaIcon = (platformName: string) => {
    switch (platformName) {
      case "Facebook":
        return <i className="feather-facebook"></i>;
      case "X":
        return <i className="feather-twitter"></i>;
      case "Instagram":
        return <i className="feather-instagram"></i>;
      case "Linkedin":
        return <i className="feather-linkedin"></i>;
      case "Youtube":
        return <i className="feather-youtube"></i>;
      default:
        return null;
    }
  };

  return { getSocialMediaIcon };
}
